import { percentage, subtract, truncateNumber } from './math/math';

export interface WagerFeeData {
  percentage?: number | null;
}

export interface WagerFeeCalculation {
  wagerFeeAmount: number;
  amountAfterWagerFee: number;
}

export const calculateWagerFee = (
  amount: number,
  wagerFee?: WagerFeeData | null,
  currencyPrecision?: number,
): WagerFeeCalculation => {
  if (!Number.isFinite(amount)) {
    return {
      wagerFeeAmount: 0,
      amountAfterWagerFee: amount,
    };
  }

  if (!wagerFee?.percentage) {
    return {
      wagerFeeAmount: 0,
      amountAfterWagerFee: amount,
    };
  }

  const wagerFeeBig = percentage(amount, wagerFee.percentage);

  const wagerFeeAmount = truncateNumber(wagerFeeBig, currencyPrecision);
  const amountAfterWagerFee = truncateNumber(subtract(amount, wagerFeeAmount), currencyPrecision); // 1111.11

  return {
    wagerFeeAmount,
    amountAfterWagerFee, // TODO: check if we need this
  };
};
